import React from 'react';
import { IMAGING_WORKLIST_PAGE_SIZE_OPTIONS } from '../../constants/imagingWorklistPagination';

export type ImagingWorklistPaginationProps = {
  currentPage: number;
  perPage: number;
  totalItems: number;
  onChangePage: (page: number) => void;
  onChangePerPage: (perPage: number) => void;
};

export default function ImagingWorklistPagination({
  currentPage,
  perPage,
  totalItems,
  onChangePage,
  onChangePerPage,
}: Readonly<ImagingWorklistPaginationProps>) {
  const totalPages = Math.max(1, Math.ceil(totalItems / perPage));
  const from = totalItems === 0 ? 0 : (currentPage - 1) * perPage + 1;
  const to = Math.min(currentPage * perPage, totalItems);

  return (
    <div className="imaging-worklist-pagination">
      <p className="imaging-worklist-pagination__summary">
        Showing {from} to {to} of {totalItems} results
      </p>
      <div className="imaging-worklist-pagination__right">
        <div className="imaging-worklist-pagination__per-page">
          <label
            htmlFor="imaging-worklist-rows-per-page"
            className="imaging-worklist-pagination__per-page-label"
          >
            Records Per Page:
          </label>
          <select
            id="imaging-worklist-rows-per-page"
            className="imaging-worklist-pagination__per-page-select"
            value={perPage}
            onChange={event => {
              const nextPerPage = Number(event.target.value);
              if (nextPerPage !== perPage) {
                onChangePerPage(nextPerPage);
              }
            }}
            aria-label="Records per page"
          >
            {IMAGING_WORKLIST_PAGE_SIZE_OPTIONS.map(pageSize => (
              <option
                key={pageSize}
                value={pageSize}
              >
                {pageSize}
              </option>
            ))}
          </select>
        </div>
        <div className="imaging-worklist-pagination__controls">
          <button
            type="button"
            disabled={currentPage <= 1}
            className="imaging-worklist-pagination__nav-btn"
            aria-label="Previous page"
            onClick={() => onChangePage(currentPage - 1)}
          >
            ‹
          </button>
          <span className="imaging-worklist-pagination__page-label">
            Page {currentPage} of {totalPages}
          </span>
          <button
            type="button"
            disabled={currentPage >= totalPages}
            className="imaging-worklist-pagination__nav-btn"
            aria-label="Next page"
            onClick={() => onChangePage(currentPage + 1)}
          >
            ›
          </button>
        </div>
      </div>
    </div>
  );
}
